import { axiosPrivate } from "../../api/axios";
import { convertAssignmentsToRecipes, filteredRecipeIngredientActions, isEmptyDay } from "../hooks/useMealDay";
export const getCustomerOrders = (onSuccess, onError) => {
    axiosPrivate.get("/MyMeals/GetCustomerOrders").then(onSuccess).catch(onError);
};
export const getDataModel = (orderNumber, allowPastCutoff, onSuccess, onError) => {
    axiosPrivate
        .get(`/MyMeals/GetMyMealsDataModel/?orderNumber=${orderNumber}&allowPastCutoff=${allowPastCutoff}`)
        .then(onSuccess)
        .catch(onError);
};
export const calculateTotal = (model, onSuccess, onError) => {
    axiosPrivate.post("/MyMeals/CalculateTotal", model).then(onSuccess).catch(onError);
};
export const updateOrder = (days, orderId, chargeForOrderUpdates, paymentMethodId, recipeIngredientReplacementMode, paymentProcessor, paymentIntentId, onSuccess, onError, giftCardId) => {
    const payload = {
        days: days
            .filter((day) => !isEmptyDay(day))
            .map((day) => {
            return {
                Meals: day.Meals,
                Products: day.Products,
                Recipes: convertAssignmentsToRecipes(day.Recipes, recipeIngredientReplacementMode),
                DateFormatted: day.DateFormatted,
                ShipDate: day.ShipDate,
            };
        }),
        orderId: orderId,
        chargeForOrderUpdates: chargeForOrderUpdates,
        paymentMethodId: paymentMethodId,
        sendUpdateCommunication: true,
        paymentProcessor: paymentProcessor,
        paymentIntentId: paymentIntentId,
        giftCardId: giftCardId,
    };
    axiosPrivate.put("/MyMeals/UpdateOrder", payload).then(onSuccess).catch(onError);
};
export const confirmThenUpdateOrder = (days, orderId, chargeForOrderUpdates, paymentMethodId, recipeIngredientReplacementMode, paymentProcessor, paymentIntentId, chargeId, onSuccess, onError) => {
    axiosPrivate
        .put("/MyMeals/ConfirmThenUpdateOrder", {
        days: days.map((day) => {
            return {
                Meals: day.Meals,
                Products: day.Products,
                Recipes: day.Recipes.map((recipe) => {
                    return {
                        RecipeId: recipe.RecipeId,
                        MealTypeIds: recipe.MealTypeIds,
                        OriginalQuantity: recipe.OriginalQuantity,
                        Quantity: recipe.Quantity,
                        ProgramMealId: recipe.ProgramMealId,
                        RecipeIngredientActions: filteredRecipeIngredientActions(recipe, recipeIngredientReplacementMode),
                    };
                }),
                DateFormatted: day.DateFormatted,
                ShipDate: day.ShipDate,
            };
        }),
        orderId: orderId,
        chargeForOrderUpdates: chargeForOrderUpdates,
        paymentMethodId: paymentMethodId,
        sendUpdateCommunication: true,
        paymentProcessor: paymentProcessor,
        paymentIntentId: paymentIntentId,
        chargeId: chargeId,
    })
        .then(onSuccess)
        .catch(onError);
};
export const getFutureOrderDataModel = (orderNumber, subLinkId, start, end, previous, future, onSuccess, onError) => {
    axiosPrivate
        .get(`/MyMeals/GetFutureOrderDataModel/?orderNumber=${orderNumber}&subscriptionLinkId=${subLinkId}&start=${start}&end=${end}&previous=${previous}&future=${future}`)
        .then(onSuccess)
        .catch(onError);
};
export const createFutureOrder = (order, recipeIngredientReplacementMode, onSuccess, onError) => {
    order.days.forEach((day) => {
        day.Recipes.forEach((recipe) => {
            recipe.RecipeIngredientActions = filteredRecipeIngredientActions(recipe, recipeIngredientReplacementMode);
        });
    });
    axiosPrivate.post(`/MyMeals/CreateFutureOrder`, order).then(onSuccess).catch(onError);
};
